import { createSlice } from "@reduxjs/toolkit";

// Step 1: Define the initial state
const initialState = {
  query: {}, // this must be an object
};
// Step 2: Create a slice
const searchQuerySlice = createSlice({
  name: "searchQuery",
  initialState,
  reducers: {
    // Action creator for updating the search query
    setReduxSearchQuery: (state, action) => {
      state.query = action.payload;
    },
    clearReduxSearchQuery: (state) => {
      state.query = {};
    },
  },
});

// Step 3: Extract action creators
export const { setReduxSearchQuery, clearReduxSearchQuery } =
  searchQuerySlice.actions;
//selector
export const selectSearchQuerySelector = (state) => state.searchQuery.query;

// Step 4: Export the reducer function
export default searchQuerySlice.reducer;
